import { ActionableIcon } from '@/app_components/common/ActionableIcon';
import { BasicModal } from '@/app_components/ui/BasicModal';
import { Icon } from '@/app_components/common/Icon';
import { Link } from '@/app_components/common/Link';
import { BankrateLogo } from '@/app_components/icons/BankrateLogo';
import { ButtonV2 } from '@/app_components/ui/ButtonV2';
import * as Dialog from '@/app_components/ui/primitives/Dialog';

interface TopSectionProps {
  title: string;
}

export const TopSection = ({ title }: TopSectionProps) => {
  const modalContent = (
    <div className='bg-pure flex flex-col p-xl gap-xl margin-safe-area md:mx-0 md:w-[90vw] md:max-w-[1000px] rounded-md relative'>
      <span className='text-center typography-level-2 font-semibold'>Advertiser Disclosure</span>
      <Dialog.Close
        asChild
        className='absolute md:top-4 md:right-4 top-2 right-2'
      >
        <ActionableIcon>
          <Icon icon='X' />
        </ActionableIcon>
      </Dialog.Close>
      <div className='flex flex-col gap-md'>
        <p>
          The rate information is obtained by Bankrate from the listed institutions. Bankrate cannot guarantee the
          accuracy or availability of any rates shown. Institutions may have different rates on their own websites than
          those posted on Bankrate.com. The listings that appear on this page are from companies from which this website
          receives compensation, which may impact how, where, and in what order products appear, except where prohibited
          by law for our mortgage, home equity and other home lending products. This table does not include all
          companies or all available products.
        </p>
        <p>
          All rates are subject to change without notice and may vary depending on location. These quotes are from
          banks, thrifts, and credit unions, some of whom have paid for a link to their own website where you can find
          additional information. Those with a paid link are our Advertisers. Those without a paid link are listings we
          obtain to improve the consumer shopping experience and are not Advertisers. To receive the Bankrate.com rate
          from an Advertiser, please identify yourself as a Bankrate customer. Bank and thrift deposits are insured by
          the Federal Deposit Insurance Corp. Credit union deposits are insured by the National Credit Union
          Administration.
        </p>
        <p>
          Consumer Satisfaction: Bankrate attempts to verify the accuracy and availability of its Advertisers' terms
          through its quality assurance process and requires Advertisers to agree to our Terms and Conditions and to
          adhere to our Quality Control Program. If you believe that you have received an inaccurate quote or are
          otherwise not satisfied with the services provided to you by the institution you choose, please{' '}
          <Link
            className='text-accent'
            href='https://www.bankrate.com/contact/'
            rel='nofollow noopener noreferrer'
            target='_blank'
          >
            click here
          </Link>
          .
        </p>
        <p>
          For details on our best products and how we chose them{' '}
          <Link
            className='text-accent'
            href='https://www.bankrate.com/contact/'
            rel='nofollow noopener noreferrer'
            target='_blank'
          >
            click here
          </Link>
          .
        </p>
      </div>
      <Dialog.Close asChild>
        <ButtonV2
          as='button'
          className='self-center'
          variant='secondary'
        >
          Close
        </ButtonV2>
      </Dialog.Close>
    </div>
  );

  const modalTrigger = (
    <span className='hover:underline font-semibold text-primary-inverse cursor-pointer'>Advertiser Disclosure</span>
  );

  return (
    <header className='flex flex-col items-start gap-5 p-4 self-stretch bg-inverse'>
      <div className='flex items-start self-stretch'>
        {/* Top Details */}
        <div className='flex flex-col md:flex-row flex-grow gap-2 justify-between'>
          <span className='uppercase font-semibold text-helper'>Advertisement</span>
          <div className='flex items-center gap-4'>
            <BasicModal
              content={modalContent}
              trigger={modalTrigger}
            />
            <span className='typography-md text-primary-inverse'>|</span>
            <Link
              href='https://www.bankrate.com/privacy/'
              rel='nofollow noopener noreferrer'
              target='_blank'
              type='white'
            >
              <span className='hover:underline font-semibold text-primary-inverse'>Policy Privacy</span>
            </Link>
          </div>
          <Link
            className='md:flex items-center gap-2 self-stretch hidden text-primary-inverse'
            href='https://www.bankrate.com/'
            rel='nofollow noopener noreferrer'
            target='_blank'
          >
            <span className='typography-xs hover:underline'>Powered by</span>
            <BankrateLogo />
          </Link>
        </div>
      </div>
      <span className='font-semibold typography-level-2 text-primary-inverse'>{title}</span>
    </header>
  );
};
